import { required, helpers } from '@vuelidate/validators';

const minLengthTrimmed = min =>
  helpers.withParams({ type: 'minLength', min }, value => {
    if (!helpers.req(value)) {
      return true;
    }

    return String(value).trim().length >= min;
  });

export default {
  title: {
    required,
    minLength: minLengthTrimmed(2),
  },
  description: {},
  showOnSidebar: {},
};
